import http, { FetchFrom } from '../http'
import { Res } from '../type'

interface SendCodeParams {
  phoneNumber: string
  areaCode?: string
  img?: string
  imgToken?: string
}

/**
 * 发送注册验证码
 * method: securityCode.registerNew
 */
export const sendRegisterCode = (params: SendCodeParams) => {
  return FetchFrom('securityCode.registerNew', {
    parameter: {
      areaCode: params.areaCode || '60',
      phoneNumber: params.phoneNumber,
      ...(params.img ? { img: params.img } : {}),
      ...(params.imgToken ? { imgToken: params.imgToken } : {})
    }
  })
}

/**
 * 校验注册信息
 */
export const verifyRegisterInfo = (params: any): Res<any> => {
  return http.request({
    url: '/api/register/verifyInfo.do',
    method: 'post',
    data: params,
    loadingShow: '1'
  })
}

/**
 * 发送验证码前校验手机号
 * method: cus.checkPhone
 */
export const checkPhoneRegister = (params: {
  phone: string
  areaCode?: string
}) => {
  return FetchFrom(
    'cus.checkPhone',
    {
      parameter: {
        areaCode: params.areaCode || '60',
        phone: params.phone
      }
    },
    [415]
  )
}

/**
 * 校验注册验证码
 * method: cus.verifyRegisterInfo
 */
export const verifyPhoneCode = (params: {
  phoneNumber: string
  areaCode?: string
  securityCode: string
}) => {
  return FetchFrom('cus.verifyRegisterInfo', {
    parameter: {
      areaCode: params.areaCode || '60',
      phoneNumber: params.phoneNumber,
      securityCode: params.securityCode
    }
  })
}

/**
 * 获取省市区信息
 * method: other.findProCityArea
 */
export const findProCityArea = () => {
  return FetchFrom('other.findProCityArea', {
    parameter: '{}'
  })
}

/**
 * 提交注册
 * method: cus.register
 */
export const submitRegister = (params: any): Promise<any> => {
  return FetchFrom('cus.register', {
    parameter: params
  })
}
